import { storeToRefs } from 'pinia';
import { useMeilisearchStore } from '~/stores/meilisearchStore';

export default defineNuxtPlugin(async () => {
    const { tenantToken } = storeToRefs(useMeilisearchStore());
    const meilisearch = useMeiliSearchRef();

    if(!tenantToken.value) return;
    meilisearch.config.apiKey = tenantToken.value;
}); 
